module.exports = __webpack_public_path__ + "static/media/search-results-page-guide.0a23ac34.png";